import { MortgageData } from '@/types/calculator';
import { calculateMortgageData } from '@/utils/calculator/mortgageCalculator';
import { useMarketData } from '@/contexts/MarketDataContext';

export const getInitialMortgageData = (): MortgageData => ({
  homePrice: 400000,
  downPayment: 80000,
  downPaymentPercentage: 20,
  interestRate: 6.5,
  loanTerm: 30,
  loanType: 'conventional',
  zipCode: '78205',
  state: 'TX',
  city: 'San Antonio',
  propertyTax: 2.00,
  pidRate: 0.54,
  includePID: true,
  homeInsurance: 1200,
  pmi: 0,
  hoaFees: 0,
  isVeteran: false,
  creditScore: 740,
  propertyType: 'singleFamily',
  location: {
    state: 'TX',
    city: 'San Antonio'
  },
  sellerCredit: 0,
  vaDisabilityStatus: null,
  vaDisabilityRatingPercentage: null,
  veteranAge: null,
  isFirstTimeHomebuyer: false,
  vaStatus: null,
  homebuyingHistory: null,
  rollFundingFeeIntoLoan: false,
  earnestMoneyDeposit: 3000,
  monthlyPayment: {
    principal: 0,
    interest: 0,
    taxes: 0,
    insurance: 0,
    pmi: 0,
    hoa: 0,
    total: 0
  },
  closingCosts: {
    total: 0,
    loanOrigination: 0,
    loanOriginationWaived: false,
    builderName: undefined,
    appraisalFee: 0,
    titleServices: 0,
    governmentRecordingCharges: 0,
    prepaids: 0,
    initialEscrow: 0,
    other: 0,
    fundingFee: 0,
    sellerCreditAmount: 0,
    totalCashNeeded: 0,
    appraisal: 0,
    inspection: 0,
    titleInsurance: 0,
    lenderFees: 0,
    otherFees: 0,
    sellerCredit: 0
  }
});

export const useInitialMortgageData = () => {
  const { getInterestRateForLoanType, marketData } = useMarketData();
  const initialData = getInitialMortgageData();
  
  // If market data is available, use live rate based on loan type
  if (marketData) {
    initialData.interestRate = getInterestRateForLoanType(initialData.loanType);
  }
  
  return calculateMortgageData(initialData);
};
